// extracted by mini-css-extract-plugin
module.exports = {"container":"Bottom_container__2AlUc","info":"Bottom_info__Rexqp","site":"Bottom_site__qaUQW","linkedin":"Bottom_linkedin__1KsG9"};